export enum ConfigurationGroupName {
    POS_SERVICE = 'POSService',
    KIOSK_SERVICE = 'KioskService',
    DELIVERY_PROVIDER = 'DeliveryProvider'
}